import React, {
  useMemo,
} from 'react';

interface GaugeIconProps extends BaseIcon {
  percentage?: number;
}
function GaugeIcon({
  className,
  percentage = 100,
}: GaugeIconProps): JSX.Element {
  const y = useMemo(() => 48 - ((48 / 100) * percentage), [percentage]);
  return (
    <svg
      viewBox="0 0 48 48"
      className={className}
    >
      <circle
        cx="24"
        cy="24"
        r="20"
        stroke="#00AFEC"
        strokeWidth="3"
        fill="none"
      />

      <mask id="mask">
        <circle cx="24" cy="24" r="18.5" fill="white" />
      </mask>
      <rect
        fill="#a6e3f9"
        mask="url(#mask)"
        width="48"
        height="48"
        y={y}
        strokeWidth="3"
        stroke="#00AFEC"
      />
    </svg>
  );
}

export default GaugeIcon;
